import { render } from "./CustomerNotesTable.vue?vue&type=template&id=9512a278"
import script from "./CustomerNotesTable.vue?vue&type=script&lang=js"
export * from "./CustomerNotesTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__